import React, { useMemo } from 'react';

import {
  DefaultItem,
  RenderMenuItem,
  UseMultiAutocompleteProps,
} from '@adsk/alloy-react-dropdown';

import {
  DropdownMultiSelect,
  DropdownMultiSelectProps,
} from '../common/DropdownMultiSelect';

type DropdownMultiSelectUrlProps<T extends DefaultItem> =
  DropdownMultiSelectProps<T> & {
    id?: string;
    onChangeItem: (value?: string) => void;
    selectedValues?: string;
    itemRenderer?: RenderMenuItem<T>;
    placeholder?: string;
  };

export const DropdownMultiSelectUrl = <T extends DefaultItem>({
  id,
  items,
  selectedValues,
  onChangeItem,
  itemRenderer,
  ...props
}: DropdownMultiSelectUrlProps<T>) => {
  const selectedItems: T[] = useMemo(() => {
    const selectedValuesArr = selectedValues?.split(',');
    if (!selectedValues || !items) return [];
    return items.filter((item) => selectedValuesArr?.includes(item.value));
  }, [selectedValues, items]);

  const onSelectedItemsChange = (
    changes: Partial<UseMultiAutocompleteProps<T>>,
  ) => {
    onChangeItem(changes.selectedItems?.map((item) => item.value).join(','));
  };

  return (
    <DropdownMultiSelect
      id={id}
      items={items}
      selectedItems={selectedItems}
      itemRenderer={itemRenderer}
      onSelectedItemsChange={onSelectedItemsChange}
      onClickClearSelectedOptions={() => onChangeItem(undefined)}
      {...props}
    />
  );
};
